import React from "react"

import * as S from "./Loading.styles"

export interface LoadingProps {
  bounceOffset?: number
  pastDelay?: boolean
}

export const Loading = ({
  bounceOffset = 50,
  pastDelay = true,
}: LoadingProps) => {
  return pastDelay ? (
    <S.Loading bounceOffset={bounceOffset}>{"•••"}</S.Loading>
  ) : null
}
